module.exports = __webpack_public_path__ + "media/call_ring.d5d3a053.mp3";